module.exports = __webpack_public_path__ + "img/a2.b914f549.svg";